import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = {
  key: 1,
  class: "col-lg-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_ProjectSummary = _resolveComponent("ProjectSummary")!
  const _component_BasecampSearchList = _resolveComponent("BasecampSearchList")!
  const _component_DataStreamList = _resolveComponent("DataStreamList")!
  const _component_TaskList = _resolveComponent("TaskList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Data Overview" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ProjectSummary, { leadID: _ctx.leadID }, null, 8, ["leadID"])
      ]),
      (_ctx.mode == 'basecamp-search')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_BasecampSearchList, { leadID: _ctx.leadID }, null, 8, ["leadID"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DataStreamList, { leadID: _ctx.leadID }, null, 8, ["leadID"])
      ]),
      (_ctx.projectDetails != null && _ctx.projectDetails.basecampProjectID != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_TaskList, {
              BasecampProjectId: _ctx.projectDetails.basecampProjectID
            }, null, 8, ["BasecampProjectId"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}